import React, { useEffect } from 'react';
import {
  Form,
  Input,
  RequiredHelpPhrase,
  Row,
  SonForm,
  SubmitButton,
  Textarea,
  TextAreaParam,
  TextParam,
  useForm,
} from '../../../_lib/Form2';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { useRefreshBlock } from '../../../_lib/BlockFetcher';

export type PageLeadBlockEditForm = {
  form: SonForm<TextParam<'title'> | TextAreaParam<'leadText'>>;
};

export function PageLeadBlockEditForm({ form }: PageLeadBlockEditForm) {
  const { t } = useSonTranslation('PageLead');
  const { formProps, fetchState, params } = useForm({ form, activateLeavingGuard: true });
  const { delayedRefresh } = useRefreshBlock();

  const leadTextParam = params.findByName('leadText');
  useEffect(() => {
    if (fetchState.type === 'success') {
      delayedRefresh();
    }
  }, [delayedRefresh, fetchState.type]);

  return (
    <Form id="page-lead-update-form" {...formProps}>
      <RequiredHelpPhrase />
      <Row>
        <Input label={t('actions.edit.inputs.title.label')} param={params.getByName('title')} />
      </Row>
      {leadTextParam && (
        <Row>
          <Textarea label={t('actions.edit.inputs.leadText.label')} param={leadTextParam} />
        </Row>
      )}
      <SubmitButton
        buttonLabel={t('actions.edit.button')}
        messageSuccess={t('actions.edit.status.success')}
        messageSending={t('actions.edit.status.sending')}
        messageFail={t('actions.edit.status.fail')}
        fetchState={fetchState}
      />
    </Form>
  );
}
